// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.28.0_@rspack+core@1.4.11_@swc+helpers@0.5.17__@swc+helpers@0._aab2582013d8636991b34b65792bdbe2/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
